import initialAppState, { AppState } from '.'

const resetAppState = (): AppState => Object.assign({}, JSON.parse(JSON.stringify(initialAppState)))

export { resetAppState }
